<!--
  搜索
  lovi 2020-08-04
-->
<template>
  <div>
    <div class="search-wrapper">
      <dl v-if="typeFlag">
        <dt>{{ $t("common.transactionType") }}</dt>
        <dd class="w100">
          <Select v-model="typeVal">
            <Option
              v-for="(item, index) in typeList"
              :value="item.key"
              :key="index"
            >
              {{ item.name }}
            </Option>
          </Select>
        </dd>
      </dl>
      <dl v-if="statusFlag">
        <dt>{{ $t("common.transactionStatus") }}</dt>
        <dd class="w100">
          <Select v-model="statusVal">
            <Option
              v-for="(item, index) in statusList"
              :value="item.key"
              :key="index"
            >
              {{ item.name }}
            </Option>
          </Select>
        </dd>
      </dl>
      <dl v-if="payTypeFlag">
        <dt>{{ $t("common.transactionMethod") }}</dt>
        <dd class="w100">
          <Select v-model="payTypeVal">
            <Option
              v-for="(item, index) in payTypeList"
              :value="item.key"
              :key="index"
            >
              {{ item.name }}
            </Option>
          </Select>
        </dd>
      </dl>
      <dl v-if="searchFlag">
        <dd class="w100">
          <Input
            v-model="searchVal"
            :placeholder="$t('common.enterSearchKeyword')"
          />
        </dd>
      </dl>
      <dl v-if="dateFlag">
        <dt>{{ $t("common.selectDate") }}</dt>
        <dd class="w100">
          <DatePicker
            :options="startOption"
            v-model="startDate"
            :placeholder="$t('common.startTime')"
          ></DatePicker>
        </dd>
        <dt>-</dt>
        <dd class="w100">
          <DatePicker
            :options="startOption"
            v-model="endDate"
            :placeholder="$t('common.endTime')"
          ></DatePicker>
        </dd>
      </dl>
      <dl v-if="dateFlag">
        <dd class="quick-date">
          <span :class="{ active: active == 1 }" @click="_getDate(0, 'DD', 1)">
            {{ $t("common.today") }}
          </span>
          <span :class="{ active: active == 2 }" @click="_getDate(-1, 'DD', 2)">
            {{ $t("common.yesterday") }}
          </span>
          <span :class="{ active: active == 3 }" @click="_getDate(7, 'DD', 3)">
            {{ $t("common.recent7days") }}
          </span>
          <span :class="{ active: active == 4 }" @click="_getDate(30, 'DD', 4)">
            {{ $t("common.recent30days") }}
          </span>
          <!-- <span :class="{'active':active == 5}" @click="_getDate(-1, 'MM', 5)">上月</span> -->
        </dd>
      </dl>
      <dl>
        <dd class="search-btn">
          <Button type="primary" @click="search">
            {{ $t("common.search") }}
          </Button>
          <Button v-if="printFlag" type="primary" @click="getExcel">
            {{ $t("common.printList") }}
          </Button>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/commonJs";
export default {
  props: {
    typeFlag: {
      //类型Flag
      type: Boolean,
      default: false
    },
    typeList: {
      //类型列表
      type: Array,
      default: function() {
        return [];
      }
    },
    statusFlag: {
      //状态Flag
      type: Boolean,
      default: false
    },
    statusList: {
      //状态列表
      type: Array,
      default: function() {
        return [];
      }
    },
    payTypeFlag: {
      //方式Flag
      type: Boolean,
      default: false
    },
    payTypeTitle: {
      //方式标题
      type: String,
      default: ""
    },
    payTypeList: {
      //方式列表
      type: Array,
      default: function() {
        return [];
      }
    },
    searchFlag: {
      //搜索Flag
      type: Boolean,
      default: false
    },
    dateFlag: {
      //日期Flag
      type: Boolean,
      default: false
    },
    printFlag: {
      //打印Flag
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      startOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      },
      typeVal: "",
      statusVal: "",
      payTypeVal: "",
      searchVal: "",
      startDate: formatDate(new Date()), //开始时间
      endDate: formatDate(new Date()), //结束时间
      active: 0 //选中状态
    };
  },
  created() {},
  mounted() {
    this.typeVal = this.typeList.length ? this.typeList[0].key : "";
    this.statusVal = this.statusList.length ? this.statusList[0].key : "";
    this.payTypeVal = this.payTypeList.length ? this.payTypeList[0].key : "";
  },
  computed: {},
  methods: {
    getExcel() {
      this.$emit("getExcel", 1);
    },
    search() {
      let vm = this;
      let data = {};
      if (vm.typeFlag) {
        data.typeVal = vm.typeVal;
      }
      if (vm.statusFlag) {
        data.statusVal = vm.statusVal;
      }
      if (vm.payTypeFlag) {
        data.payTypeVal = vm.payTypeVal;
      }
      if (vm.searchFlag) {
        data.searchVal = vm.searchVal;
      }
      // if (vm.startDate == "") {
      //   vm.$Message.warning("开始时间不能为空");
      //   return;
      // }
      // if (vm.endDate == "") {
      //   vm.$Message.warning("结束时间不能为空");
      //   return;
      // }
      if (vm.dateFlag) {
        data.startDate = formatDate(vm.startDate);
        data.endDate = formatDate(vm.endDate);
        if (data.startDate > data.endDate) {
          vm.$Message.warning(vm.$t("common.endTimeCannotLessBeginningTime"));
          return false;
        }
      }
      console.log("search", data);
      vm.$emit("search", data);
    },
    _getDate(num, string, index) {
      if (this.active == index) {
        return;
      }
      let newTime = {};
      this.active = index;
      newTime = this.dateSelection(num, string);
      // if (num == 7) { //获取本周
      // 	let date = new Date();
      // 	let timestamp = date.getTime(); //当天时间戳
      // 	let weekday = date.getDay();
      // 	newTime.startDate = timestamp - 3600 * 1000 * 24 * weekday;
      // 	newTime.endDate = timestamp;
      // } else {
      // 	newTime = this.dateSelection(num, string);
      // }
      console.log(newTime.startDate, "newTime.startDate");
      this.startDate = new Date(newTime.startDate);
      this.endDate = new Date(newTime.endDate);
      this.search();
    },
    dateSelection(num, string) {
      //string 类型 只能传 MM  DD , YY等于年，MM等于月， DD 等于天
      //num 当前筛选的条件 0 代表当前 1等于今天 昨天；
      let date = new Date();
      let timestamp = date.getTime(); //当天时间戳
      let day = date.getDate(); //获取当天
      let time = date.toLocaleDateString(); //当前年月日
      let newDate = {
        startDate: "",
        endDate: ""
      };
      newDate.endDate = time;
      if (!string || string == "DD") {
        let newBegin = timestamp - Math.abs(num) * 3600 * 1000 * 24; //正数取开始时间
        if (num != Math.abs(num)) {
          newDate.endDate = new Date(newBegin).toLocaleDateString();
        }
        newDate.startDate = new Date(newBegin).toLocaleDateString();
      }
      if (string == "MM") {
        if (Math.abs(num) > 12) {
          return false;
        }
        if (num == 0) {
          //本月的开始时间
          var mm_month = time.split("/");
          mm_month.splice(2, 1, "1");
          newDate.startDate = mm_month.join("/");
        } else {
          let newendDate = timestamp - day * 3600 * 1000 * 24; //这个是上个月最后一天时间戳
          let last = new Date(newendDate).toLocaleDateString(); //这个是上个月最后一天日期
          for (var i = 0; i < Math.abs(num) - 1; i++) {
            var dateArry = last.split("/");
            var dayString = dateArry[dateArry.length - 1];
            newendDate = newendDate - dayString * 3600 * 1000 * 24;
            last = new Date(newendDate).toLocaleDateString(); //这个是上个月最后一天日期
          }
          if (num == Math.abs(num)) {
            var mm_current = time.split("/");
            if (last.split("/")[2] < mm_current[2]) {
              mm_current[2] = last.split("/")[2];
            }
            if (mm_current[1] - num <= 0) {
              mm_current[0] = mm_current[0] - 1;
              mm_current[1] = 12 - Math.abs(mm_current[1] - num);
            } else {
              mm_current.splice(1, 1, mm_current[1] - num);
            }
            newDate.startDate = mm_current.join("/");
          } else {
            var mm_rvery = last.split("/");
            mm_rvery.splice(2, 1, "1");
            newDate.startDate = mm_rvery.join("/");
            newDate.endDate = new Date(newendDate).toLocaleDateString();
          }
        }
      }
      return newDate;
    }
  },
  components: {},
  watch: {
    typeList: {
      handler(arr) {
        if (arr.length) {
          this.typeVal = arr[0].key;
        }
      },
      immediate: true
    },
    statusList: {
      handler(arr) {
        if (arr.length) {
          this.statusVal = arr[0].key;
        }
      },
      immediate: true
    },
    payTypeList: {
      handler(arr) {
        if (arr.length) {
          this.payTypeVal = arr[0].key;
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.search-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 20px 0;
  /deep/.ivu-input:focus,
  /deep/.ivu-input:hover,
  /deep/.ivu-select-visible .ivu-select-selection,
  /deep/.ivu-select-selection-focused,
  /deep/.ivu-select-selection:hover {
    border-color: #2042ab;
  }
  /deep/.ivu-select-item-selected,
  /deep/.ivu-select-item-selected:hover {
    color: #2042ab;
  }
  .w100 {
    width: 120px;
  }
  dl {
    margin: 5px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    dt {
      line-height: 32px;
      padding-right: 8px;
    }
    dd {
      flex: 1;
      width: auto;
      margin-right: 8px;
      &.quick-date {
        display: flex;
        justify-content: flex-start;
        span {
          cursor: pointer;
          display: inline-block;
          margin-right: 8px;
          // min-width: 72px;
          text-align: center;
          padding: 0 10px;
          line-height: 30px;
          color: #2042ab;
          border: 1px solid #2042ab;
          border-radius: 4px;
          &:last-child {
            margin-right: 0;
          }
          &.active {
            color: #fff;
            background: #2042ab;
            border-color: #2042ab;
          }
        }
      }
      button {
        margin-right: 8px;
        min-width: 70px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
}
</style>
